/**
 * Read the HTTP status off a caught error without asserting its type.
 *
 * `catchError` hands back `unknown`, and the value is only an `HttpErrorResponse` when the failure
 * actually came off the wire — an interceptor, a mapping operator, or a test double can emit
 * anything. Narrowing structurally (rather than with `instanceof HttpErrorResponse`) keeps the
 * 404 branch working for all of those while avoiding an implicit `any`.
 *
 * @returns the numeric status, or null when the error carries none.
 */
export function getErrorStatus(error: unknown): number | null {
  if (typeof error !== 'object' || error === null) {
    return null;
  }

  const status = (error as { status?: unknown }).status;
  return typeof status === 'number' ? status : null;
}
